import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  Box,
  MenuItem,
  SelectChangeEvent
} from "@mui/material";
import { displayStudyLoadingState, displayStudyState } from "features/optimization/state/studyAtoms";
import { hoveredOptCFDidState, selectedOptCFDState } from "features/optimization/state/trialAtoms";
import { determinePresetId, OBJECTIVE_PRESETS } from "shared/domain/objectivePresets";
import { buildCFDStatusFromStudy } from "features/optimization/utils/studyMappers";
import { LoadingSelect } from "shared/ui/LoadingSelect";

export const TrialSelector: React.FC = () => {
  const setHoveredOptCFDid = useSetRecoilState(hoveredOptCFDidState);
  const [selectedOptCFD, setSelectedOptCFD] = useRecoilState(selectedOptCFDState);
  const displayStudy = useRecoilValue(displayStudyState);
  const displayStudyLoading = useRecoilValue(displayStudyLoadingState);

  // 表示中のstudyからLIMEで使うtrial一覧を組み立てる
  const presetId = displayStudy?.presetId ?? determinePresetId(displayStudy?.cfd_id_list || {});
  const preset = OBJECTIVE_PRESETS[presetId];
  const baseKey = preset.objectives[0]?.key;
  const baseCfdIdList = displayStudy?.cfd_id_list?.cfd_id_list_1 ?? [];

  const handleDropdownClick = () => {
    if (displayStudyLoading) return;
    if (!displayStudy) {
      alert("OptimizationタブからStudy Nameを選択し、グラフ描画をしてください。");
    }
  };

  const handleSelectedStudyChange = (event: SelectChangeEvent<string>) => {
    setHoveredOptCFDid(null);
    const cfd_id = event.target.value as string;

    const index = baseCfdIdList.indexOf(cfd_id);

    if (displayStudy) {
      const status = buildCFDStatusFromStudy(displayStudy, presetId, index);
      setSelectedOptCFD(status);
    }
  };

  const handleMouseEnter = (cfd_id: string) => {
    setHoveredOptCFDid(cfd_id);
  };

  const handleMouseLeave = () => {
    setHoveredOptCFDid(null);
  };

  return (
    <Box component="div" sx={{ paddingTop: 1, paddingBottom: 1 }}>
      <LoadingSelect
        label="select trial id"
        labelId="studies-history-select-label"
        id="studies-history-select"
        value={
          (baseKey ? selectedOptCFD?.cfd_id?.[baseKey] : '') ||
          ""
        }
        onClick={handleDropdownClick}
        onChange={handleSelectedStudyChange}
        loading={displayStudyLoading}
      >
        {(baseCfdIdList || []).map((cfd_id) => (
          <MenuItem
            key={cfd_id}
            value={cfd_id}
            onMouseEnter={() => handleMouseEnter(cfd_id)}
            onMouseLeave={handleMouseLeave}
          >
            {cfd_id}
          </MenuItem>
        ))}
      </LoadingSelect>
    </Box>
  );
};
